import { render, staticRenderFns } from "./TournamentEditAbout.vue?vue&type=template&id=97cfdac6&scoped=true"
import script from "./TournamentEditAbout.vue?vue&type=script&lang=js"
export * from "./TournamentEditAbout.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditAbout.vue?vue&type=style&index=0&id=97cfdac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cfdac6",
  null
  
)

export default component.exports